module.exports = __webpack_public_path__ + "img/App-Store.74d0c428.svg";